'use client';
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React from 'react';
import { styled } from '@mui/material/styles';
var StyledSvg = styled('svg')(function (_ref) {
    var theme = _ref.theme;
    return _defineProperty({
        width: '32px',
        height: '32px',
        flexShrink: 0,
        position: 'absolute'
    }, theme.breakpoints.down('sm'), {
        width: '24px',
        height: '24px'
    });
});
var PickerCircle = function PickerCircle(_ref3) {
    var color = _ref3.color, className = _ref3.className;
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        role: "presentation"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: "16.5",
        cy: "16",
        r: "16",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "16.5",
        cy: "16",
        r: "15.5",
        stroke: "black",
        strokeOpacity: "0.1"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "16.5",
        cy: "16",
        r: "8",
        fill: color
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "16.5",
        cy: "16",
        r: "7.5",
        stroke: "black",
        strokeOpacity: "0.1"
    }));
};
export default PickerCircle;
